// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/Background/about_bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/images/AboutImage/airplane.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about_main_section__eXIfZ {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;

  .about_heroSection__9yOW5 {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    /* height: 50vh; */
    margin: 3rem 0;
  }
}

.about_trade_section__g0HlS {
  max-width: 100%;
  margin: 0;
  padding: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right
      center,
    linear-gradient(90deg, #ff5c00 0%, #7412dd 100%);
  background-size: contain, cover;
  height: auto;

  .about_section__Xgv0S {
    margin: 4rem 0;
    & h6 {
      color: var(--text-color);
      font-family: Inter;
      font-size: 2rem;
      font-weight: 700;
    }

    & p {
      margin: 0;
      color: var(--text-color);
      font-family: Inter;
      font-size: 0.8rem;
      font-weight: 500;
    }
  }
}

.about_imageSection__FjMuP {
  margin: 0;
  max-width: 100%;
  height: 100%;

  & img {
    max-width: 100%;
    height: auto;
  }

  .about_right_section__gIIl8 {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: #1e1e1e;
  }
}

.about_grid_section__ldcw- {
  display: grid;
  grid-template-columns: 30% 70%;
  width: 100%;
  height: 100vh;
}

.about_left_side__TAEgz {
  color: var(--text-color);
}

.about_right_side__8CSmW {
  height: calc(87% - 4px);
  background-color: #1e1e1e;
  padding: 5rem;

  & h5 {
    color: var(--text-color);
    font-family: Inter;
    font-size: 2rem;
    font-weight: 700;
  }

  & h6 {
    padding-top: 0.6rem;
    color: var(--text-color);
    font-family: Inter;
    font-size: 1rem;
    font-weight: 600;
  }

  & p {
    width: 70%;
    padding-left: 1.6rem;
    color: var(--text-color);
    font-family: Inter;
    font-size: 0.9rem;
    font-weight: 400;
  }
}

/* -------media-queries--------- */

@media screen and (max-width: 568px) {
  .about_main_section__eXIfZ {
    background-color: #1e1e1e;
    height: auto;

    .about_heroSection__9yOW5 {
      margin: 0 0 1rem;
    }
  }

  .about_grid_section__ldcw- {
    display: grid;
    grid-template-columns: 100%;
    height: auto;

    .about_right_side__8CSmW {
      height: auto;
      padding: 1rem;

      & p {
        width: 100%;
      }
    }
  }

  .about_trade_section__g0HlS .about_section__Xgv0S {
    margin: 1rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/About/about.module.css"],"names":[],"mappings":"AAAA;EACE,yDAAgE;EAChE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;;EAEV;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV;;oDAEkD;EAClD,+BAA+B;EAC/B,YAAY;;EAEZ;IACE,cAAc;IACd;MACE,wBAAwB;MACxB,kBAAkB;MAClB,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,SAAS;MACT,wBAAwB;MACxB,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;;EAEZ;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;;EAEb;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,kCAAkC;;AAElC;EACE;IACE,yBAAyB;IACzB,YAAY;;IAEZ;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,YAAY;;IAEZ;MACE,YAAY;MACZ,aAAa;;MAEb;QACE,WAAW;MACb;IACF;EACF;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".main_section {\n  background-image: url(\"/public/images/Background/about_bg.webp\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n\n  .heroSection {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    /* height: 50vh; */\n    margin: 3rem 0;\n  }\n}\n\n.trade_section {\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  background: url(\"/public/images/AboutImage/airplane.png\") no-repeat right\n      center,\n    linear-gradient(90deg, #ff5c00 0%, #7412dd 100%);\n  background-size: contain, cover;\n  height: auto;\n\n  .section {\n    margin: 4rem 0;\n    & h6 {\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 2rem;\n      font-weight: 700;\n    }\n\n    & p {\n      margin: 0;\n      color: var(--text-color);\n      font-family: Inter;\n      font-size: 0.8rem;\n      font-weight: 500;\n    }\n  }\n}\n\n.imageSection {\n  margin: 0;\n  max-width: 100%;\n  height: 100%;\n\n  & img {\n    max-width: 100%;\n    height: auto;\n  }\n\n  .right_section {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    background-color: #1e1e1e;\n  }\n}\n\n.grid_section {\n  display: grid;\n  grid-template-columns: 30% 70%;\n  width: 100%;\n  height: 100vh;\n}\n\n.left_side {\n  color: var(--text-color);\n}\n\n.right_side {\n  height: calc(87% - 4px);\n  background-color: #1e1e1e;\n  padding: 5rem;\n\n  & h5 {\n    color: var(--text-color);\n    font-family: Inter;\n    font-size: 2rem;\n    font-weight: 700;\n  }\n\n  & h6 {\n    padding-top: 0.6rem;\n    color: var(--text-color);\n    font-family: Inter;\n    font-size: 1rem;\n    font-weight: 600;\n  }\n\n  & p {\n    width: 70%;\n    padding-left: 1.6rem;\n    color: var(--text-color);\n    font-family: Inter;\n    font-size: 0.9rem;\n    font-weight: 400;\n  }\n}\n\n/* -------media-queries--------- */\n\n@media screen and (max-width: 568px) {\n  .main_section {\n    background-color: #1e1e1e;\n    height: auto;\n\n    .heroSection {\n      margin: 0 0 1rem;\n    }\n  }\n\n  .grid_section {\n    display: grid;\n    grid-template-columns: 100%;\n    height: auto;\n\n    .right_side {\n      height: auto;\n      padding: 1rem;\n\n      & p {\n        width: 100%;\n      }\n    }\n  }\n\n  .trade_section .section {\n    margin: 1rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `about_main_section__eXIfZ`,
	"heroSection": `about_heroSection__9yOW5`,
	"trade_section": `about_trade_section__g0HlS`,
	"section": `about_section__Xgv0S`,
	"imageSection": `about_imageSection__FjMuP`,
	"right_section": `about_right_section__gIIl8`,
	"grid_section": `about_grid_section__ldcw-`,
	"left_side": `about_left_side__TAEgz`,
	"right_side": `about_right_side__8CSmW`
};
export default ___CSS_LOADER_EXPORT___;
